<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="500px"
    title="更新状态"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div v-loading="laoding" class="content">
      <el-form ref="form" label-position="top" :model="form" :rules="rules">
        <el-form-item label="状态" prop="status" style="width: 100%;">
          <el-select
            v-model="form.status"
            placeholder="请选择"
            style="width: 100%;"
            clearable
          >
            <el-option
              v-for="item in config.otherStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div v-loading="laoding" class="cancel flex_c_c" @click="cancel">取消</div>
      <div v-loading="laoding" class="ok flex_c_c" @click="ok('form')">确定</div>
    </span>
  </el-dialog>
</template>

<script>
import config from '@/utils/config'
import { updateOtherServiceStatus } from '@/api/other'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    otherServiceIDs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config,
      form: {
        status: ''
      },
      rules: {
        status: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ]
      },
      laoding: false
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          this.laoding = true
          try {
            const params = {
              ...this.form,
              otherServiceIDs: this.otherServiceIDs
            }
            const res = await updateOtherServiceStatus(params)
            this.laoding = false
            if (res.success) {
              this.$emit('ok')
              this.$message.success(res.errorMessage)
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.error(error)
          }
        } else {
          this.laoding = false
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 80px);
  margin: 0 auto;
  .el-form {
    width: 100%;
  }
}
.footers {
  display: flex;
  justify-content: center;
  & > div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
  .cancel {
    background: #EEEEEE;
    color: #999999;
    margin-right: 16px;
  }
  .ok {
    background: #2395f3;
    color: #ffffff;
  }
}
</style>
